import { useState, useEffect, useCallback } from "react";
import AdminHeader from "../header";
import AdminSidebar from "../sidebar";
import { Icon1, Icon2, User2, course02 } from "../../imagepath";
import { Link } from "react-router-dom";
import AdminServices from "../../../services/AdminServices";
import $ from "jquery";
import "datatables.net-dt/css/dataTables.dataTables.min.css";
import "datatables.net";
const TeachersLists = () => {
  const [isClassAdded, setIsClassAdded] = useState([false]);
  const [teachers, setTeachers] = useState([]);
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const toggleClass = (index) => {
    const updatedClasses = [...isClassAdded];
    updatedClasses[index] = !updatedClasses[index];
    setIsClassAdded(updatedClasses);
  };
  const fetchTeachers = useCallback(async () => {
    try {
      const response = await AdminServices.getAllTeachers({
        page: currentPage,
        search,
      });
      console.log("getAllTeachers: ", response);
      setTeachers(response.teachers); // Ensure this is an array
      setTotalPages(response.totalPages);
    } catch (error) {
      console.error("Error fetching Teachers:", error);
    }
  }, [currentPage, search]); // Include currentPage and search as dependencies

  const handleSearch = (e) => {
    setSearch(e.target.value);
  };

  const handlePageChange = (page) => {
    if (page > 0 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  useEffect(() => {
    fetchTeachers();
  }, [fetchTeachers]); // fetchTeachers now has stable dependencies
  useEffect(() => {
    if (teachers.length === 0) return; // Prevent initializing if no data

    if ($.fn.DataTable.isDataTable("#teachersTable")) {
        $("#teachersTable").DataTable().destroy(); // Destroy old instance before reinitializing
    }

    $("#teachersTable").DataTable({
        responsive: true,
        autoWidth: false,
        paging: true, // ✅ Enable Pagination
        searching: true,
        ordering: true,
        pageLength: 10, // ✅ Set default entries per page
        lengthMenu: [[10, 25, 50, -1], [10, 25, 50, "All"]], // ✅ Add pagination options
    });
}, [teachers]);
  return (
    <>
      {/* Main Wrapper */}
      <div className="main-wrapper">
        {/* Header */}
        <AdminHeader activeMenu={"Dashboard"} />
        {/* /Header */}
        {/* Breadcrumb */}
        <div className="breadcrumb-bar breadcrumb-bar-info">
          <div className="container">
            <div className="row">
              <div className="col-md-12 col-12">
                <div className="breadcrumb-list">
                  <h2 className="breadcrumb-title">Teachers List</h2>
                  <nav aria-label="breadcrumb" className="page-breadcrumb">
                    <ol className="breadcrumb">
                      <li className="breadcrumb-item">
                        <Link to="/home">Home</Link>
                      </li>
                      <li
                        className="breadcrumb-item active"
                        aria-current="page"
                      >
                        Teachers List
                      </li>
                    </ol>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* /Breadcrumb */}
        {/* Page Content */}
        <div className="page-content">
          <div className="container">
            <div className="row">
              {/* sidebar */}
              <AdminSidebar />
              {/* /Sidebar */}
              {/* School Dashboard */}
              <div className="col-xl-9 col-lg-9">
                {/* Dashboard Grid */}
                {/* <div className="row justify-content-center">
                                    <div className="col-lg-4 col-md-6 d-flex">
                                        <div className="card dash-info flex-fill">
                                            <div className="card-body">
                                                <h5>Total School</h5>
                                                <h2>1</h2>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-6 d-flex">
                                        <div className="card dash-info flex-fill">
                                            <div className="card-body">
                                                <h5>Total User</h5>
                                                <h2>2</h2>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-6 d-flex">
                                        <div className="card dash-info flex-fill">
                                            <div className="card-body">
                                                <h5>Total Course</h5>
                                                <h2>1</h2>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}
                {/* /Dashboard Grid */}
                <div className="dashboard-title">
                  <h4>Teachers List</h4>
                </div>
                <div className="row">
                  {/* Course Grid */}
                  <div className="table-responsive custom-table">
                    <table
                      id="teachersTable"
                      className="table table-nowrap mb-0"
                    >
                      <thead>
                        <tr>
                          <th></th>
                          <th>Teacher Name</th>
                          <th>School Name</th>
                          <th>Signed up</th>
                          <th>Signup Date</th>
                          <th>Payment</th>
                          <th>Payment Date</th>
                          <th>Payment By</th>
                          <th>Course Completed Date</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {teachers.map((teacher, index) => (
                          <tr key={teacher._id}>
                            <td>{index + 1}</td>
                            <td>
                                {teacher.name}
                            </td>
                            <td>{teacher.school_id ? teacher.school_id.name : "N/A"}</td> 
                            <td>{teacher?.issignup ? "Yes" : "No"}</td>
                            <td>
                            {teacher?.signupdate
                                ? new Date(
                                    teacher?.signupdate
                                ).toLocaleString()
                                : "N/A"}
                            </td>
                            <td>
                              {teacher.payment?.amount
                                ? `$${teacher.payment.amount.toFixed(2)}`
                                : "N/A"}
                            </td>
                            <td>
                              {teacher.payment?.startDate
                                ? new Date(
                                    teacher.payment.startDate
                                  ).toLocaleString()
                                : "N/A"}
                            </td>
                            <td>
                              {teacher.payment
                                ? teacher.payment.schoolId
                                  ? "School"
                                  : teacher.payment.userId
                                  ? "Individual Teacher"
                                  : "N/A"
                                : "N/A"}
                            </td>
                            <td>
                                               {teacher?.quizResults?.[0]?.completionDate
                                                    ? new Date(
                                                        teacher.quizResults[0].completionDate
                                                    ).toLocaleString()
                                                    : "N/A"}
                                               </td>
                            <td>
                              {teacher?.school_id ?'':
                              <Link to="/certificates" className="action-icon">
                               View Certificates
                              </Link>}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
                {/* <div className="dash-pagination">
                  <div className="row align-items-center">
                    <div className="col-6">
                      <p>Page 1 of 2</p>
                    </div>
                    <div className="col-6">
                      <ul className="pagination">
                        <li className="active">
                          <Link to="#">1</Link>
                        </li>
                        <li>
                          <Link to="#">2</Link>
                        </li>
                        <li>
                          <Link to="#">
                            <i className="bx bx-chevron-right" />
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div> */}
              </div>
              {/* School Dashboard */}
            </div>
          </div>
        </div>
        {/* /Page Content */}
        {/* Footer */}

        {/* /Footer */}
      </div>
      {/* /Main Wrapper */}
    </>
  );
};

export default TeachersLists;
